import clsx from "clsx";
import { useAtom } from "jotai";
import { useEffect, useMemo, useState } from "react";
import { useErrorHandler } from "react-error-boundary";

import { updateFormioSubmission } from "../../../shared/api/yenta-api";
import { LanderQuizButton } from "../../../shared/components/lander-quiz-components/lander-quiz-button/lander-quiz-button.component";
import { MediaDisplayer } from "../../../shared/components/lander-quiz-media-displayer/media-displayer/media-displayer.component";
import {
  landerCplQuizAtom,
  landerCplQuizQuestionAtom,
  landerCplQuizQuestionIndexAtom,
} from "../../lander-cpl-quiz.state";
import { entriesCount } from "../../utils";

export const LanderCplQuizBody: React.FC = () => {
  const [landerCplQuiz] = useAtom(landerCplQuizAtom);
  const [currentIndex] = useAtom(landerCplQuizQuestionIndexAtom);
  const [currentQuestion, setCurrentQuestion] = useAtom(
    landerCplQuizQuestionAtom(currentIndex)
  );
  const [buttonDisabledOnAnswered, setButtonDisabledOnAnswered] = useState(
    false
  );
  const handleWidgetError = useErrorHandler();

  const optionClick = (selectedId: string) => {
    setCurrentQuestion((question) => ({
      ...question,
      options: question.options.map((option) => ({
        ...option,
        isSelected: option.id === selectedId,
      })),
      answer: question.title,
    }));
    setButtonDisabledOnAnswered(true);
  };

  const quizExtraEntries = useMemo(
    () => entriesCount(landerCplQuiz.questions, 0),
    [landerCplQuiz.questions]
  );

  useEffect(() => {
    const submission = window.theme.Sweepstake.prototype.retrieveSubmission();
    if (!submission) {
      return;
    }

    const sweepFormUrl =
      document
        .querySelector("#FormSweepstake")
        ?.getAttribute("data-form-path-url") ?? "";
    const patchData = {
      ...submission.data,
      quizExtraEntries:
        quizExtraEntries + (landerCplQuiz.prevExtraEntries || 0),
    };

    updateFormioSubmission(
      sweepFormUrl,
      {
        ...submission,
        data: patchData,
      },
      handleWidgetError
    ).then((submission) => {
      window.theme.Sweepstake.prototype.storeSubmission(submission);
      window.theme.Sweepstake.prototype.storeSubmissionHash(submission);
    });
  }, [quizExtraEntries, handleWidgetError, landerCplQuiz.prevExtraEntries]);

  useEffect(() => {
    setButtonDisabledOnAnswered(false);
  }, [currentIndex]);

  return (
    <div key={currentQuestion.id} className="lander__cpl__quiz__body">
      <MediaDisplayer
        media={[currentQuestion.media]}
        stepIndex={currentIndex}
      />
      <div className="lander__cpl__quiz__body--question-container">
        <div className="lander__cpl__quiz__body--question-header">
          <div className="lander__cpl__quiz__body--question-entries">
            + 1 <br /> Entry
          </div>
          <div className="lander__cpl__quiz__body--question-title">
            {currentQuestion.title}
          </div>
        </div>
        <div className="lander__cpl__quiz__body--question-actions">
          {currentQuestion.options.map((option) => {
            return (
              <div
                key={`option-${option.id}`}
                className={clsx(
                  "lander__cpl__quiz__body--button-container",
                  option.isSelected && option.isCorrect && "active-background"
                )}
              >
                <LanderQuizButton
                  key={option.id}
                  isSelected={option.isSelected}
                  isCorrect={option.isCorrect}
                  disabled={buttonDisabledOnAnswered}
                  onClickOption={() => optionClick(option.id)}
                >
                  {option.title}
                </LanderQuizButton>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
